import React from 'react'

const EventManager = () => {
  return (
    <div>EventManager</div>
  )
}

export default EventManager